export const articleAudioPlayer = () => {
    const audio = document.getElementById('audio');

    if (!audio) {
        return;
    }

    const clips = Array.from(audio.querySelectorAll('source'));
    const paywallButtons = document.querySelector(
        '.article-audio-player--paywall-buttons',
    );
    const playButton = document.querySelector('.audio__play-button');
    const playIcon = document.querySelector('.play-icon');
    const pauseIcon = document.querySelector('.pause-icon');
    const remainingTime = document.querySelector(
        '.article-audio-player__time__remaining',
    );
    const currentTime = document.querySelector(
        '.article-audio-player__time__current',
    );
    const playbackRates = [1, 1.25, 1.5, 1.75, 2, 0.5];
    const playbackRateButton = document.querySelector('.playback-rate__button');

    let currentRateIndex = 1;

    const handlePlayBackRate = () => {
        const playbackRate = playbackRates[currentRateIndex];
        audio.playbackRate = playbackRate;
        playbackRateButton.innerHTML = `${playbackRate}X`;

        currentRateIndex++;
        if (currentRateIndex >= playbackRates.length) {
            currentRateIndex = 0;
        }
    };

    let currentClipIndex = 0;

    const playNextClip = () => {
        if (clips.length <= 1) {
            return;
        }

        currentClipIndex++;
        if (currentClipIndex < clips.length) {
            audio.src = clips[currentClipIndex].src;
            audio.play();

            if (paywallButtons) {
                paywallButtons.classList.add('show');
            }
        }
    };

    const convertSecondsToMinutes = (seconds) => {
        let minutes = Math.floor(seconds / 60);
        let remainingSeconds = Math.floor(seconds % 60);

        minutes = minutes < 10 ? '0' + minutes : minutes;
        remainingSeconds =
            remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;

        return `${minutes}:${remainingSeconds}`;
    };

    playbackRateButton.addEventListener('click', handlePlayBackRate);

    // Adds the duration of the audio after the audio has loaded.
    audio.onloadedmetadata = function () {
        currentTime.innerHTML = convertSecondsToMinutes(audio.currentTime);
        remainingTime.innerHTML = convertSecondsToMinutes(audio.duration);
    };

    // Updates the current time of the audio.
    audio.addEventListener('timeupdate', () => {
        currentTime.innerHTML = convertSecondsToMinutes(audio.currentTime);
    });

    audio.addEventListener('ended', playNextClip);

    playButton.addEventListener('click', () => {
        remainingTime.innerHTML = convertSecondsToMinutes(audio.duration);
        audio.paused ? audio.play() : audio.pause();

        playIcon.style.display = audio.paused ? 'block' : 'none';
        pauseIcon.style.display = audio.paused ? 'none' : 'block';
    });
};

